import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { HistorySequenceRow } from "../types/timeEfficiency.types";
import { TE_COLORS } from "./theme";

interface HistoryModalProps {
  open: boolean;
  projectId: string | null;
  sequencia: HistorySequenceRow[] | undefined;
  loading?: boolean;
  onClose: () => void;
}

export function HistoryModal({
  open,
  projectId,
  sequencia,
  loading,
  onClose,
}: HistoryModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: TE_COLORS.blue,
          fontWeight: 700,
        }}
      >
        Histórico de status {projectId ? `— ${projectId}` : ""}
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress size={28} />
          </Box>
        ) : !sequencia || !sequencia.length ? (
          <Typography
            sx={{
              color: TE_COLORS.textFaint,
              fontSize: 12.5,
              textAlign: "center",
              py: 3,
            }}
          >
            Sem histórico detalhado disponível para este projeto (dado de
            demonstração ou relatório sem essa informação).
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Entrou em</TableCell>
                <TableCell>Saiu em</TableCell>
                <TableCell>Duração</TableCell>
                <TableCell>Ocorrência</TableCell>
                <TableCell>Justificativa</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sequencia.map((e, idx) => (
                <TableRow
                  key={idx}
                  sx={e.ocorrencia > 1 ? { bgcolor: "#FDF1E7" } : undefined}
                >
                  <TableCell>
                    {e.status}
                    {e.ocorrencia > 1 && (
                      <Typography
                        component="span"
                        sx={{
                          ml: 0.75,
                          display: "inline-block",
                          bgcolor: TE_COLORS.orange,
                          color: "#fff",
                          fontSize: 9.5,
                          fontWeight: 700,
                          px: 0.75,
                          borderRadius: "8px",
                        }}
                      >
                        retorno
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>{e.entrouEm}</TableCell>
                  <TableCell>{e.saiuEm}</TableCell>
                  <TableCell>{e.duracaoTexto}</TableCell>
                  <TableCell>{e.ocorrencia}ª vez</TableCell>
                  <TableCell>{e.justificativa || "–"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}
